import { gettext_noop } from 'lib/gettext'

const sourceText = {
  personal: gettext_noop(
    'Use this option if you are an expert in the field and you rely on your ' +
      'knowledge, experience and expertise to create and populate this entry.'
  ),
  secondary: gettext_noop(
    'Secondary Source entry, prepared from a literature review by a Ph.D. RA'
  ),
  expert: gettext_noop(
    'Expert Source entry, prepared by a Ph.D. RA or DRH Editor ' +
      "from an expert's published work(s), and then personally edited and approved by the expert."
  ),
  supervised: gettext_noop('Supervised Entry'),
}

export default sourceText
